export default __webpack_public_path__ + "static/media/featured1.png";